import React from 'react'
import { GridHeader, GridRow } from 'src/components/Reusable/Grid'
import { useControlsColumnsVisibility } from '../../IndexItem/ControlsListItem.helpers'
import { ControlListItemConfig } from '../../IndexItem/ControlListItem.constants'
import { ControlsGridHeader } from './ControlsIndexGrid.styles'
import {
  ControlsIndexGridOwnerHeader,
  ControlsIndexGridOperatingEffectivenessHeader,
  ControlsIndexGridDepartmentHeader,
  ControlsIndexGridFrameworksHeader,
  ControlsIndexGridIdHeader,
  ControlsIndexGridLinkedEvidenceHeader,
  ControlsIndexGridNameHeader,
  ControlsIndexGridStatusHeader,
  ControlsIndexGridLabelsHeader,
  ControlsIndexGridRisksHeader,
} from './ControlsIndexGrid.components'

export const ControlsIndexGridHeader = ({
  config,
  showContentMatchColumn,
}: {
  config?: ControlListItemConfig
  showContentMatchColumn?: boolean
}): JSX.Element => {
  const {
    showDepartment,
    showId,
    showName,
    showLabels,
    showRisk,
    showFrameworks,
    showEvidence,
    showOperatingEffectiveness,
    showStatus,
    showOwner,
    showAssignees,
    showMenu,
  } = useControlsColumnsVisibility(config)

  return (
    <GridRow>
      {showContentMatchColumn && <GridHeader />}
      {showDepartment && <ControlsIndexGridDepartmentHeader />}
      {showId && <ControlsIndexGridIdHeader />}
      {showName && <ControlsIndexGridNameHeader />}
      {showLabels && <ControlsIndexGridLabelsHeader />}
      {showRisk && <ControlsIndexGridRisksHeader />}
      {showFrameworks && <ControlsIndexGridFrameworksHeader />}
      {showEvidence && <ControlsIndexGridLinkedEvidenceHeader />}
      {showOperatingEffectiveness && (
        <ControlsIndexGridOperatingEffectivenessHeader />
      )}
      {showStatus && <ControlsIndexGridStatusHeader />}
      {showOwner && <ControlsIndexGridOwnerHeader />}
      {showAssignees && (
        <ControlsGridHeader justifyContent="flex-start">
          Assignees
        </ControlsGridHeader>
      )}
      {showMenu && <ControlsGridHeader />}
    </GridRow>
  )
}
